// @flow

const shouldNotIgnoreFacet = facetsToIgnore => ([facetId]) => (
  !facetsToIgnore.includes(facetId)
);

// eslint-disable-next-line no-unused-vars
function reduceTotalLength(acc: any, [_, amountOfSelectedOptions]: any): number {
  return acc + amountOfSelectedOptions.length;
}

const INITIAL_COUNTER = 0;

export function getAppliedFacetsCount(
  appliedFacets: any = {},
  facetsToIgnore: any = []
): number {
  return Object
    .entries(appliedFacets)
    .filter(shouldNotIgnoreFacet(facetsToIgnore))
    .reduce(reduceTotalLength, INITIAL_COUNTER);
}
